import { isEmpty } from 'lodash';
import moment from 'moment';
import { twentyFourHours } from 'types';
import { apiContent } from 'utilities/http/api/pupDocs/apiContent';

export const pupDocsContentKey = 'pupDocsContent';
export let PupDocsContent = JSON.parse(localStorage.getItem(pupDocsContentKey) ?? '{}');

export const fetchPupDocsContent = async () => {
  const response = await apiContent.getPupDocsContent();
  if (response.isOk && typeof response.json.pupdocsContent === 'object') {
    const content = {
      ...response.json.pupdocsContent,
      fetchedDate: new Date().toISOString(),
    };

    localStorage.setItem(pupDocsContentKey, JSON.stringify(content));
  }
};

export function isPupDocsContentExpired() {
  const differenceBetweenFetchedDateAndNow = moment().diff(
    PupDocsContent.fetchedDate,
    'hours',
  );

  return twentyFourHours < differenceBetweenFetchedDateAndNow;
}

export const getPupDocsContentStorage = async () => {
  if (
    isEmpty(PupDocsContent) ||
    !localStorage.getItem(pupDocsContentKey) ||
    isPupDocsContentExpired()
  ) {
    await fetchPupDocsContent();
    PupDocsContent = JSON.parse(localStorage.getItem(pupDocsContentKey) as string);
  }
};
